import { render, staticRenderFns } from "./WxApp.vue?vue&type=template&id=52e4047e&scoped=true&"
import script from "./WxApp.vue?vue&type=script&lang=js&"
export * from "./WxApp.vue?vue&type=script&lang=js&"
import style0 from "./WxApp.vue?vue&type=style&index=0&id=52e4047e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4047e",
  null
  
)

export default component.exports